import Script from 'next/script'
import { MessageCircle } from 'react-feather'
import getConfig from 'next/config'
import { useSessionContext } from '@contexts/session'
import { useEffect, useRef } from 'react'

const { publicRuntimeConfig } = getConfig()

declare global {
  interface Window {
    Inkeep: any
    inkeepWidget: any
  }
}

const InkeepWidget = () => {
  const { id, email, name } = useSessionContext()
  const chatButtonRef = useRef<HTMLButtonElement>(null)

  const handleOpenChange = (newOpen: boolean) => {
    window.inkeepWidget &&
      window.inkeepWidget.update({ modalSettings: { isOpen: newOpen } })
  }

  const initInkeep = () => {
    if (!window.Inkeep) {
      setTimeout(initInkeep, 200)
      return
    }

    const config = {
      baseSettings: {
        apiKey: publicRuntimeConfig.NEXT_PUBLIC_INKEEP_API_KEY,
        primaryBrandColor: '#ff5a43',
        organizationDisplayName: 'Codingal',
        userProperties: {
          id: id || 'anonymous',
          email: email || 'anonymous@example.com',
          name: name || 'Anonymous User',
        },
      },
      searchSettings: {},
      aiChatSettings: {
        exampleQuestions: [
          'How to take renewal PTM?',
          'How to change curriculum?',
        ],
      },
      modalSettings: {
        onOpenChange: handleOpenChange,
      },
    }

    window.inkeepWidget = window.Inkeep.ModalChat(config)
    attachClickHandler() // Attach the click handler once the widget is initialized
  }

  const attachClickHandler = () => {
    const chatBtn = chatButtonRef.current
    if (chatBtn) {
      chatBtn.removeEventListener('click', handleChatButtonClick)
      chatBtn.addEventListener('click', handleChatButtonClick)
    }
  }

  const handleChatButtonClick = () => {
    if (window.inkeepWidget) {
      window.inkeepWidget.update({ modalSettings: { isOpen: true } })
    }
  }

  useEffect(() => {
    initInkeep() // Initialize the widget when the component mounts
  }, [id, email, name]) // Re-initialize if user data changes

  useEffect(() => {
    // Cleanup event listeners when the component unmounts
    return () => {
      const chatBtn = chatButtonRef.current
      if (chatBtn) {
        chatBtn.removeEventListener('click', handleChatButtonClick)
      }
    }
  }, []) // Empty array ensures this effect runs only on unmount

  return (
    <>
      <div id="inkeepModal">
        <button
          ref={chatButtonRef}
          id="chat-button"
          className="py-1 px-3 text align-middle font-600 text-white focus:outline-none rounded-2xl flex bg-orange shadow-md hover:bg-orange-500 hover:shadow-lg duration-300"
          aria-label="Ask AI"
        >
          <MessageCircle className="w-5 mr-1" /> <span>Ask AI</span>
        </button>
      </div>
      <Script
        type="module"
        src="https://cdn.jsdelivr.net/npm/@inkeep/cxkit-js@0.5/dist/embed.js"
        strategy="afterInteractive"
      />
    </>
  )
}
export default InkeepWidget
